module.exports = __webpack_public_path__ + "img/CONTRATO DE GUATEMALA-1.9804a48e.jpg";